import type { editor, IPosition, IRange, Position } from 'monaco-editor'

type _IRange = IRange & {
  asPositions: () => [startPosition: IPosition, endPosition: IPosition]
}

export class ModelContextFinder {
  public static findFocusedWord(
    model: editor.ITextModel,
    at: Position,
  ): _IRange {
    const atIndex = this.findCurrentIndex(model, at)
    const text = model.getValue()

    const startIndex = this.currentWordStart(text, atIndex - 1)
    const endIndex = this.currentWordEnd(text, atIndex)

    const start = at.delta(0, startIndex - atIndex)
    const end = at.delta(0, endIndex - atIndex)

    return {
      startLineNumber: start.lineNumber,
      startColumn: start.column,
      endLineNumber: end.lineNumber,
      endColumn: end.column,
      asPositions() {
        return ModelContextFinder.asPositions(this)
      },
    }
  }

  public static asPositions(
    range: IRange,
  ): [startPosition: IPosition, endPosition: IPosition] {
    return [
      {
        lineNumber: range.startLineNumber,
        column: range.startColumn,
      },
      {
        lineNumber: range.endLineNumber,
        column: range.endColumn,
      },
    ]
  }

  private static currentWordStart(text: string, at: number) {
    let i = at

    while (i >= 0 && /\w/.test(text[i])) {
      i--
    }

    return i + 1 // add 1 to point at last character of word
  }

  private static currentWordEnd(text: string, at: number) {
    let i = at

    while (i < text.length && /\w/.test(text[i])) {
      i++
    }

    return i
  }

  private static findCurrentIndex(model: editor.ITextModel, at: IPosition) {
    const beforePosition = model.getValueInRange({
      startLineNumber: 0,
      startColumn: 0,
      endLineNumber: at.lineNumber,
      endColumn: at.column,
    })

    return beforePosition.length
  }
}
